import styled from 'styled-components';
import {
  xxlBold,
  smRegular,
  mdBold,
  xsBold,
} from '@hud/web-components/theme/typography';
import { themeColor } from '@hud/web-components/theme/colors';
import { Container } from '@hud/web-components/Container/Container';
import { Button } from '@hud/web-components/Button/Button';
import { Markdown } from '@hud/web-components/Markdown/Markdown';

export const Header = styled.header`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 20px;
`;

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: 6px;
  width: 100%;
`;

export const HeaderTitle = styled.h1`
  ${xxlBold};
  margin: 0;
`;

export const HeaderSubtitle = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  ${smRegular};
  color: ${themeColor('textTertiary')};
`;

export const EditButton = styled(Button)`
  padding: 6px 14px 6px 8px;
`;

export const ViewIssuesButton = styled(Button)`
  padding: 6px 14px 6px 8px;
`;

export const DetectionLogicContainer = styled(Container)`
  padding-top: 24px;
  flex: 5;
  ${smRegular};
  color: ${themeColor('textSecondary')};
  background: ${themeColor('tooltipBackground')};
`;
export const DetectionLogicHeader = styled.div`
  color: ${themeColor('textPrimary')};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DetectionLogicTitle = styled.h3`
  ${mdBold};
  margin: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${themeColor('textPrimary')};
`;

export const DetectionLogicActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const DetectionLogicDescriptionValue = styled.span`
  ${xsBold};

  display: inline-flex;
  padding: 6px 8px;
  align-items: center;
  border-radius: 6px;
  background: ${themeColor('buttonBackgroundHover')};
  margin: 1px 3px;
`;

export const DetectionLogicDescriptionContainer = styled.div`
  width: fit-content;
`;

export const DetectionLogicDescription = styled(Markdown).attrs({
  components: {
    Value: DetectionLogicDescriptionValue,
  },
})``;

export const DetectionLogicParametersContainer = styled.div`
  border-block-start: 1px solid ${themeColor('strokeSecondary')};
  padding-block-start: 20px;
`;

export const DetectionLogicParametersTitle = styled.h3`
  margin: 0;
  padding-block-end: 14px;
  ${mdBold};
`;

export const Main = styled.main`
  display: flex;
  flex-direction: row;
  gap: 20px;
  overflow: hidden;
`;

export const AboutContainer = styled.div<{ paramsLength: number }>`
  flex: 3;
  ${smRegular};

  min-height: 200px;
  height: fit-content;
  max-height: ${({ paramsLength }) => `${(paramsLength + 1) * 20}vh`};
  display: flex;
  flex-direction: column;
  padding: 24px 20px 40px 20px;
  align-items: flex-start;
  gap: 20px;

  border-radius: 8px;
  background: ${themeColor('buttonBackground')};
  background:
    radial-gradient(
      circle at 50% 130%,
      rgba(80, 136, 193, 0.7) 0%,
      transparent 70%
    ),
    /* bottom right */
      radial-gradient(
        circle at 150% 140%,
        rgba(118, 84, 252, 0.3) 0%,
        transparent 50%
      ),
    /* bottom left */
      radial-gradient(
        circle at -50% 160%,
        rgba(15, 254, 230, 0.3) 0%,
        transparent 50%
      ),
    #292b2e;
`;

export const AboutHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  gap: 10px;
  ${mdBold};
`;

export const AboutContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  word-break: break-word;
  overflow-wrap: break-word;
  overflow: auto;
  line-height: 154%;

  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
`;

export const AboutTitle = styled.h2`
  color: ${themeColor('textPrimary')};
  margin: 0;
  ${mdBold};
`;

export const AboutDescription = styled(Markdown)`
  ${smRegular};
`;

export const AboutButton = styled(Button).attrs({
  variant: 'text',
})`
  text-decoration: underline;
`;

export const LastApplied = styled.div`
  border-top: 1px solid ${themeColor('strokePrimary')};
  padding-top: 20px;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const TableHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;

  margin-bottom: 20px;
  align-items: center;
  padding-right: 20px;
  padding-left: 20px;
`;

export const Service = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const ServicesListRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ShownServices = styled.div`
  display: flex;
  gap: 8px;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 90%;
`;

export const ServicesPopover = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
`;

export const MoreItemsContainer = styled.div`
  position: absolute;
  right: 0;
  margin-right: 8px;
`;

export const MoreItemButton = styled(Button).attrs({ variant: 'outlined' })`
  display: flex;
  height: 22px;
  padding: 0 5px 2px 5px;
  align-items: center;
  gap: 2px;
`;
